import { createSelector } from '@reduxjs/toolkit';
import { SettingsState } from './types';

const selectSettingsBase = createSelector(
	(state: RootState) => state,
	(state: RootState) => state.settingsReducer,
);

export const selectSettings = createSelector(
	selectSettingsBase,
	(state: SettingsState) => state.settings,
);

export const selectSettingDefaultPerson = createSelector(
	selectSettingsBase,
	(state: SettingsState) => state.settings?.default_person_id,
);

export const selectSettingBrancName = createSelector(
	selectSettingsBase,
	(state: SettingsState) => state.settings?.brand_name || '',
);

export const selectMapBackgroundImage = createSelector(
	selectSettingsBase,
	(state: SettingsState) => state.settings?.background_image_url,
);

export const selectRestoreToVisitCountdown = createSelector(
	selectSettingsBase,
	(state: SettingsState) => state.settings?.restore_to_visit_countdown,
);
